import React, { useState } from 'react';
import { withRouter } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { Button, Form } from 'react-bootstrap';
import Api from '../Services/Api';
import Alert from '../Services/Alert';

export const ClearData = (props) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data) => {
        const confirmResult = await Alert.warning("Are you sure you want to permanently delete data older than the selected date? This action cannot be undone.");

        if (confirmResult.isConfirmed) {
            setLoading(true);
            Api.post('settings/clear-data', data).then((res) => res.data).then(res => {
                setLoading(false);
                if (res.status) {
                    Alert.success(`${res.message}. Deleted: Bids: ${res.data.market_bids_deleted}, Txns: ${res.data.transactions_deleted}, Logs: ${res.data.bid_logs_deleted}`);
                } else {
                    Alert.error(res.message);
                }
            }).catch(error => {
                setLoading(false);
                Alert.error(error.message);
            });
        }
    }

    return (
        <>
            <section className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title mb-4">Clear Historical Data</h4>
                                        <Form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Select Date (Delete data BEFORE or ON this date)</Form.Label>
                                                        <Form.Control type="date" className="form-control" {...register("date", { required: true })} />
                                                        {errors.date && <div className="error">Date is required.</div>}
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="alert alert-warning">
                                                        <strong>Warning:</strong> This action will permanently delete:
                                                        <ul>
                                                            <li>Market Bids</li>
                                                            <li>Transactions</li>
                                                            <li>Bid Update Logs</li>
                                                        </ul>
                                                        Data created on or before the selected date will be removed.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="btn-submit">
                                                <Button className="btn btn-danger w-md" type="submit" disabled={loading}>
                                                    {loading ? 'Clearing Data...' : 'Clear Data'}
                                                </Button>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )

}
export default withRouter(ClearData);
